import { useQuery } from "react-query"

import { useOrgs } from "../../../components/providers/OrgProvider"
import { getBboxQueryParams, Bbox } from "../../helpers/map"
import { BikeEntity, BikeState } from "../../types/bike"
import { AssetType } from "../../types/bikeModel"

interface Props {
  bbox?: Bbox
  search: string
  bikeStates: BikeState[]
  bikeModels: string[]
  bikeTags: string[]
}

export interface MapBikeEntity extends Partial<BikeEntity> {
  uuid: string
  latitude: number
  longitude: number
  state?: BikeState
  bicycle_type?: AssetType
}

export function useGetMapBikesQuery({ bbox, bikeStates, bikeModels, bikeTags, search }: Props) {
  const { currentOrgs } = useOrgs()
  const bikeStateQuery = bikeStates.reduce((acc, s) => acc + `&state=${s}`, "")
  const bikeModelQuery = bikeModels.reduce((acc, s) => acc + `&model=${s}`, "")
  const bikeTagQuery = bikeTags.reduce((acc, s) => acc + `&tag=${s}`, "")
  const bboxParams = bbox && getBboxQueryParams(bbox)

  // If searching for a bike, dont use bbox from map to filter
  const searchQuery = search ? `&query=${search}` : bboxParams

  const currentOrgsUuids = currentOrgs.map(({ uuid }) => uuid)

  const bikeUrl = `bicycles/?organizations=${currentOrgsUuids.join()}&no_page=1${searchQuery}${bikeStateQuery}${bikeModelQuery}${bikeTagQuery}&include_state=true&has_lock=true`

  const fields = `&fields=latitude,longitude,state,uuid,organization,last_cellular_update,model,bicycle_type`

  const { data, isFetching: bikesLoading } = useQuery<MapBikeEntity[], [string, string]>(bikeUrl + fields, {
    refetchInterval: 30000,
    keepPreviousData: true,
  })

  const bikes = data || []
  return { bikes, bikesLoading }
}
